import { FC, SVGAttributes } from 'react';

import Clock from '@/assets/icons/Clock';
import Plaatsconflict from '@/assets/icons/Plaatsconflict';
import TrainManco from '@/assets/icons/TrainManco';
import VerkeerdMat from '@/assets/icons/VerkeerdMat';
import { ConflictType } from '@/types/Conflicten';

import styles from '../Conflict.module.css';

// Map conflict types to icon names
const conflictIconMap = {
  MANCO: TrainManco,
  PLAATS: Plaatsconflict,
  VERKEERD_MATERIEEL: VerkeerdMat,
  VERSTERKT_MATERIEEL: VerkeerdMat,
};

// Function to get icon component from conflict type
const conflictTypeIcon = (type: ConflictType) => conflictIconMap?.[type] ?? Clock;

// Omit `name` from Icon props, since it's internally derived
type ConflictIconProps = SVGAttributes<SVGSVGElement> & {
  conflictType: ConflictType;
};

const ConflictIcon: FC<ConflictIconProps> = ({ conflictType, ...iconProps }) => {
  const IconComponent = conflictTypeIcon(conflictType);
  return (
    <IconComponent
      className={styles.conflictenIconStyle}
      aria-hidden='true'
      width='24px'
      height='24px'
      {...iconProps}
    />
  );
};

export default ConflictIcon;
